module.exports = __webpack_public_path__ + "assets/img/yypt_d_p1.96b16ffb.png";